import styled from 'styled-components'

type TypeButton ={
    color?: string,
    spam?: boolean,
    outlined?: boolean,
}
export const ButtonShare = styled.button<TypeButton> `
    
    background:transparent;
    border-radius: 5px 5px 5px 5px;
    width:45px;
    height:44px;
    outline: none;
    border-style: none;
    right: 0;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    ${props => !props.outlined ? 
        `&:hover{
            background:  ${props.color};
        }`: ''}
    & > span {
        color: black;
        position: absolute;
        display: block;
        font-size: 0.6rem;
        color: #7b6e6e;
        visibility: ${props => !props.spam ? 'hidden' : 'visible'};
        opacity: ${props => !props.spam ? '0' : '1'};
        transition: visibility .6s, opacity 0.9s linear;
    }
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        height:27px;
    }
`
